import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

type BaseProps = {
  as?: string;
  className?: string;
  dangerouslySetInnerHTML?: any;
  numeric?: boolean;
  outline?: boolean;
} & React.ComponentProps<any>;

export const Base = ({
  as = 'p',
  className,
  dangerouslySetInnerHTML,
  numeric = false,
  outline = false,
  ...props
}: BaseProps) => {
  let El = as;

  if (props.dangerouslySetInnerHTML && as === 'p') {
    El = 'div';
  }
  return (
    <El
      className={twMerge(
        clsx(
          'mb-16 mt-0 block font-normal tracking-normal [&>*]:mt-0',
          numeric && 'font-medium',
          outline && 'text-stroke-outline',
          className,
        ),
      )}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      {...props}
    />
  );
};

export const Heading1 = ({ className, ...props }: BaseProps) => (
  <Base
    as="h1"
    className={twMerge(clsx('text-6xl font-black leading-wound tracking-[-0.5px] md:text-8xl lg:text-9xl', className))}
    {...props}
  />
);

export const Heading2 = ({ className, ...props }: BaseProps) => (
  <Base
    as="h2"
    className={twMerge(
      clsx('text-5xl font-black leading-wound tracking-normal md:text-7xl md:tracking-[-0.5px]', className),
    )}
    {...props}
  />
);

export const Heading3 = ({ className, ...props }: BaseProps) => (
  <Base as="h3" className={twMerge(clsx('text-4xl font-black leading-wound md:text-6xl', className))} {...props} />
);

export const Heading4 = ({ className, ...props }: BaseProps) => (
  <Base as="h4" className={twMerge(clsx('text-xl font-medium leading-gripped md:text-3xl', className))} {...props} />
);

export const Body = ({ className, ...props }: BaseProps) => (
  <Base
    as="p"
    className={twMerge(clsx('min-h-[1.5em] text-md font-normal leading-normal md:text-lg [&>*]:last:mb-0', className))}
    {...props}
  />
);

export const SmallText = ({ className, ...props }: BaseProps) => (
  <Base
    as="p"
    className={twMerge(clsx('text-sm font-normal leading-[22px] md:text-md md:leading-[24px]', className))}
    {...props}
  />
);
